import { WorkflowDto } from "@babackapp/private-api-client/types";
import { createContext, FC, PropsWithChildren, useContext } from "react";

type WorkflowContextType = {
  currentWorkflow: WorkflowDto;
};

type WorkflowContextProviderProps = PropsWithChildren<WorkflowContextType>;

const WorkflowContext = createContext<WorkflowContextType | undefined>(
  undefined,
);

export const WorkflowPageProvider: FC<
  PropsWithChildren<WorkflowContextProviderProps>
> = ({ children, ...props }) => {
  return (
    <WorkflowContext.Provider
      value={{
        ...props,
      }}
    >
      {children}
    </WorkflowContext.Provider>
  );
};

export const useWorkflowContext = () => {
  const context = useContext(WorkflowContext);
  if (context === undefined) {
    throw new Error("useWorkflowContext must be used within a WorkflowContext");
  }
  return context;
};
